<template>
  <!-- 客户仓库下方辅料卡片列表：只展示传入的接口数据 -->
  <div class="warehouse-material-list">
    <!-- 单个辅料卡片 -->
    <div v-for="(item, index) in list" :key="item.id || index" class="warehouse-material-card">
      <!-- 辅料主图，缺少图片时保留灰色占位 -->
      <div class="material-card-image">
        <el-image v-if="item.material && item.material.main_image" :src="item.material.main_image" fit="cover"
          :preview-src-list="[item.material.main_image]" />
      </div>

      <!-- 辅料名称、库存数量和消耗信息 -->
      <div class="material-card-content">
        <!-- 名称超出一行时使用省略号 -->
        <div class="material-title-row">
          <el-tooltip :content="item.material && item.material.name_trans" placement="top"
            :disabled="!(item.material && item.material.name_trans)">
            <span class="material-card-name">{{ item.material && item.material.name_trans }}</span>
          </el-tooltip>
        </div>

        <!-- 辅料类型标签 -->
        <el-tag class="material-type-tag" size="mini" effect="plain">
          {{ item.material && item.material.type && (item.material.type.name_trans || item.material.type.name) }}
        </el-tag>

        <!-- 当前辅料库存数量 -->
        <div class="material-stock-row">
          {{ $t('message.inventoryQuantity') }}：{{ item.material && item.material.material_stock_num }}
        </div>

        <!-- 单套消耗数量 -->
        <div class="material-consume-row">
          <span>{{ $t('message.materialConsumption') }}：</span>
          <span class="material-consume-value">{{ item.consume }}</span>
          <span>{{ $t('message.pointsPerSet') }}</span>
        </div>
      </div>

      <!-- 卡片底部预计消耗数量 -->
      <div class="material-expected-row">
        {{ $t('message.expectedConsumption') }}：{{ getExpectedConsumption(item) }}
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 客户仓库专用辅料卡片。
 * 与公共辅料组件隔离，只负责按照仓库列表截图展示库存、消耗和预计消耗。
 */
export default {
  name: 'WarehouseMaterialCard',
  props: {
    // stockMaterialBindList 返回的辅料数组
    list: {
      type: Array,
      default: () => []
    },
    // 当前商品可提出数量，用于计算预计消耗
    orderQuantity: {
      default: 0
    }
  },
  methods: {
    // 预计消耗等于辅料单套消耗乘以当前商品数量
    getExpectedConsumption(item) {
      const consume = Number(item.consume)
      const orderQuantity = Number(this.orderQuantity)
      if (!Number.isFinite(consume) || !Number.isFinite(orderQuantity)) return 0
      return consume * orderQuantity
    }
  }
}
</script>

<style lang="scss" scoped>
// 辅料卡片列表按可用宽度自动换行
.warehouse-material-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 244px));
  gap: 14px;
  width: 100%;
  min-width: 0;
  /* 与UI参考图对齐：卡片列表向右、向下留出2px内边距 */
  padding: 20px;
  box-sizing: border-box;
  justify-content: start;
}

// 单个辅料卡片
.warehouse-material-card {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 126px;
  padding: 12px 12px 38px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
}

// 辅料图片区域
.material-card-image {
  flex: 0 0 72px;
  width: 72px;
  height: 72px;
  margin-right: 10px;
  background: #9b9b9b;
  overflow: hidden;

  .el-image {
    display: block;
    width: 100%;
    height: 100%;
  }
}

// 辅料名称、库存和消耗内容区域
.material-card-content {
  flex: 1;
  min-width: 0;
  color: #333;
  font-size: 12px;
  line-height: 18px;
}

// 名称与说明按钮同一行
.material-title-row {
  display: flex;
  align-items: center;
  min-width: 0;
  margin-bottom: 2px;
}

// 辅料名称超出宽度时省略
.material-card-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 截图中的绿色说明按钮
.material-notice-button {
  flex: none;
  height: 22px;
  margin-left: 6px;
  padding: 2px 7px;
  border-color: #13b23f;
  background: #13b23f;
  font-size: 12px;
  line-height: 16px;
}

// 说明浮层内容
.material-notice {
  line-height: 20px;
  white-space: pre-wrap;
  word-break: break-word;
}

// 辅料类型标签
.material-type-tag {
  display: block;
  width: fit-content;
  height: 18px;
  margin-bottom: 2px;
  padding: 0 4px;
  border-color: #b3d8ff;
  color: #409eff;
  line-height: 16px;
}

// 库存数量行
.material-stock-row {
  white-space: nowrap;
}

// 消耗行
.material-consume-row {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

// 消耗数值沿用截图中的输入框视觉
.material-consume-value {
  display: inline-block;
  min-width: 34px;
  margin: 0 4px;
  padding: 0 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  text-align: center;
}

// 预计消耗固定在卡片底部
.material-expected-row {
  position: absolute;
  right: 10px;
  bottom: 0;
  left: 10px;
  height: 30px;
  border-top: 1px solid #dcdfe6;
  line-height: 30px;
  text-align: right;
  white-space: nowrap;
}
</style>
